<template>
  <el-container class="full-height bg-gray">
    <el-main class="page-content">
      <el-main class="container">
        <!-- <Nav>
          <div slot="right">
            <el-button v-show="hasAuthority('addClassify')" type="primary" @click="handleAdd">新增分类</el-button>
          </div>
        </Nav> -->
        <div class="table">
          <Table
            border
            align="center"
            :header-row-style="{height: '100px'}"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            :row-style="{height: '150px'}"
            :column="column"
            :data="datasource.data"
          >
          </Table>
      </div>
      </el-main>
    </el-main>

    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :destroy-on-close="true"
      width="25%">
      <div class="dialog-title">{{dialogTitle}}</div>
      <div class="form-box">
        <div class="item">
          <span class="title">分类名称:</span>
          <el-input placeholder="请输入分类名称" v-model="body.name" style="width: 200px"></el-input>
        </div>
        <div class="item">
          <div class="title">排列序号:</div>
          <el-input placeholder="请输入排列序号" type="number" v-model="body.indexNum" style="width: 200px"></el-input>
        </div>
        <div class="item">
          <div class="title">分类图片（{{imgNum}}/1）</div>
          <UpLoadImg
            :img="banners"
            :length='1'
            :size="[350, 180]"
            @get-files="getFiles"/>
        </div>
        <div class="btn-box">
          <el-button type="primary" @click="handleUpdate">确定</el-button>
          <el-button @click="handleClose">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import {
  getFunList,
  updateFun
} from '@/api/industry'
import UpLoadImg from '@/components/upload-img'
export default {
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
      banners: [],
      datasource: {
        data: []
      },
      body: {
        indexNum: '',
        name: '',
        picture: '',
        uuid: ''
      },
      column: [
        {
          prop: 'indexNum',
          label: '排列序号'
        },
        {
          prop: 'name',
          label: '分类名称'
        },
        {
          label: '分类图片',
          render: (h, scoped) => {
            const url = `${window.$imgUrl}${scoped.row.picture}`
            if (scoped.row.picture) {
              return (
                <div>
                  <img src={url} width={100} height={100}/>
                </div>
              )
            } else {
              return (
                <div>
                </div>
              )
            }
          }
        },
        {
          label: '操作',
          width: '300',
          render: (h, scoped) => {
            return (
              <div>
                <el-link v-show={this.hasAuthority('editClassify')} underline={false} type='primary' onClick={() => { this.handleDetail(scoped.row) }}>编辑</el-link>&nbsp;&nbsp;
              </div>
            )
          }
        }
      ],
      imgNum: 0
    }
  },
  created() {
    this.network().getFunList()
  },
  methods: {
    network() {
      return {
        getFunList: async() => {
          const { data } = await getFunList()
          this.datasource.data = data
        },
        updateFun: async() => {
          await updateFun(this.body)
          this.dialogVisible = false
          this.$message.success('更新成功')
          this.network().getFunList()
        }
      }
    },
    handleDetail(row) {
      this.banners = []
      this.imgNum = 0
      if (row.picture) {
        this.banners.push(row.picture)
        this.imgNum = 1
      }
      this.body.indexNum = row.indexNum
      this.body.name = row.name
      this.body.picture = row.picture
      this.body.uuid = row.uuid
      this.dialogVisible = true
      this.dialogTitle = '编辑分类'
    },
    checkForm() {
      if (this.body.name === '') {
        this.$message.error('请输入分类名称!')
        return false
      } else if (this.body.indexNum === '') {
        this.$message.error('请输入序号!')
        return false
      } else if (this.body.picture === '') {
        this.$message.error('请上传图片!')
        return false
      }
      return true
    },
    handleUpdate() {
      if (!this.body.picture) {
        this.body.picture = ''
        this.banners = []
      }
      if (this.checkForm()) {
        this.network().updateFun()
      }
    },
    handleClose() {
      this.banners = []
      this.body.indexNum = ''
      this.body.name = ''
      this.body.picture = ''
      this.body.uuid = ''
      this.dialogVisible = false
    },
    getFiles(file, files) {
      this.banners = []
      if (files.length > 0) {
        this.body.picture = file.response
        this.banners.push(file.response)
        this.imgNum = 1
      } else {
        this.banners = []
        this.body.picture = ''
        this.imgNum = 0
      }
    },
    handleAdd(){
      this.dialogVisible = true
      this.dialogTitle = '新增分类'
    }
  },
  components: {
    UpLoadImg
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog{
  /deep/.el-dialog__header {
    padding: 0;
  }
  border-radius: 15px;
  .form-box{
    .item{
      margin: 30px 0;
      .title{
        margin-bottom: 15px;
      }
    }
    .btn-box{
      display: flex;
      justify-content: center;
    }
  }

  .dialog-title{
    font-size: 20px;
    font-weight: bold;
  }

  /deep/.el-upload-list__item{
    transition: none !important;
  }
}
</style>
